// plugins/google-recaptcha.client.ts
import { VueReCaptcha } from "vue-recaptcha-v3";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  if (!config.public.recaptchaSiteKey) {
    console.warn("⚠️ ReCAPTCHA siteKey is missing.");
    return;
  }

  const options: any = {
    siteKey: config.public.recaptchaSiteKey,
    loaderOptions: {
      autoHideBadge: true,
      explicitRenderParameters: {
        badge: "bottomleft",
      },
    },
  };

  nuxtApp.vueApp.use(VueReCaptcha, options);
  nuxtApp.provide("recaptcha", nuxtApp.vueApp.config.globalProperties.$recaptcha);
});
